import { ChangeDetectionStrategy, Component, inject, LOCALE_ID } from '@angular/core';

import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DateService } from '@softline/core';
import {
  DateInputComponent,
  FieldValidationDirective,
  NumberInputComponent,
  ResolvableModal,
  Validators,
} from '@softline/ui-core';
import { AddMileageBody } from '../../models/vehicle';
import { formatDateForRequest } from '../../utils/format-date-for-request.function';

@Component({
  selector: 'soft-add-mileage-form',
  templateUrl: './add-mileage-form.component.html',
  styleUrl: './add-mileage-form.component.css',
  imports: [
    ReactiveFormsModule,
    FieldValidationDirective,
    NumberInputComponent,
    DateInputComponent
],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddMileageFormComponent extends ResolvableModal<
  { data: AddMileageBody } | 'CANCEL'
> {
  readonly #fb = inject(FormBuilder);
  readonly #locale = inject(LOCALE_ID);
  readonly #dateService = inject(DateService);

  mileageForm = this.#fb.group({
    date: new FormControl<string | undefined>(this.#dateService.now(), {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    mileage: new FormControl<number | undefined>(0, {
      validators: [Validators.required()],
      nonNullable: true,
    }),
    operatingHours: new FormControl<number | undefined>(0, {
      validators: [Validators.required()],
      nonNullable: true,
    }),
  });

  submit() {
    if (this.mileageForm.invalid) return;
    const formData = this.mileageForm.getRawValue();

    const formattedDate = formatDateForRequest(formData.date ?? '', this.#locale);

    this.resolve({
      data: {
        date: formattedDate,
        mileage: formData.mileage,
        operatingHours: formData.operatingHours,
      } as AddMileageBody,
    });
  }
}
